import React, { useEffect, useState } from "react";
import * as API from "src/api/high_risk";
import * as REQ from "src/api/request";
import * as REFERENCE from "src/api/risk/reference";
import moment from "moment";
import { DatePicker, Input, Select } from "antd";
import List from "src/pages/high_risk/register/list";
import Header from "src/pages/high_risk/register/header";
import DepartmentTreeCode from "src/components/departmentTreeCode";
import { useUserContext } from "src/contexts/userContext";
import { useHighRiskContext } from "src/contexts/high_risk/highriskContext";
import MatrixCons from "src/components/Matrix_consequences";
import MatrixProb from "src/components/Matrix_probabilities";
import _ from "lodash";

import Swal from "sweetalert2";

const { TextArea } = Input;
const { Option } = Select;

const Index = () => {
  const { user, message } = useUserContext();
  const { state, dispatch } = useHighRiskContext();
  const [list, setlist] = useState([]);

  const valid = () => {
    let validation = "";

    // state.approve.type_id || (validation += "Гүйцэтгэл сонгоно уу <br />");
    // if (state.approve.type_id === 19) {
    //   state.approve.comment ||
    //     (validation += "Дахин гүйцэтгэх тайлбар оруулна уу <br />");
    // }
    console.log(state.register.approve_comment);

    if (validation !== "") {
      Swal.fire({
        icon: "warning",
        html: validation,
      });
    } else {
      API.putRegister(state.register.id, {
        approve_id: state.register.approve_type_id,
        approve_comment:
          state.register.approve_comment === undefined
            ? null
            : state.register.approve_comment,
      })
        .then((res) => {
          dispatch({
            type: "STATE",
            data: { refresh: state.refresh + 1 },
          });
          message({
            type: "success",
            title: "Амжилттай хадгалагдлаа.",
          });
        })
        .catch((error) =>
          message({
            type: "error",
            error,
            title: "Хадгалахад алдаа гарлаа, дахин оролдно уу",
          })
        )
        .finally(() => {});
    }
  };

  return (
    <div className="flex flex-col text-xs">
      <div className="flex items-center">
        <span className="w-1/3 font-semibold">
          Төлөв:<b className="ml-1 text-red-500">*</b>
        </span>
        <Select
          showSearch
          allowClear
          placeholder="Сонгоно уу."
          optionFilterProp="children"
          className="w-full"
          value={state.register.approve_type_id}
          onChange={(value) => {
            dispatch({
              type: "STATE",
              data: {
                register: {
                  ...state.register,
                  approve_type_id: value,
                },
              },
            });
          }}
        >
          <Option key={41} value={41}>
            НЗХГ ажлын жагсаалтанд оруулах
          </Option>
          <Option key={42} value={42}>
            Эрсдлийг дахин үнэлэх
          </Option>
        </Select>
      </div>
      <hr className="my-2" />
      <div className="flex items-center">
        <span className="w-1/3 font-semibold pr-3">
          Тайлбар:<b className="ml-1 text-red-500">*</b>
        </span>
        <TextArea
          rows={4}
          placeholder="Зөрчлийн талаар дэлгэрэнгүй"
          value={state.register.approve_comment}
          className="w-full"
          onChange={(e) =>
            dispatch({
              type: "STATE",
              data: {
                register: {
                  ...state.register,
                  approve_comment: e.target.value,
                },
              },
            })
          }
        />
      </div>
      <hr className="my-2" />

      <button
        className="w-full py-2 flex items-center justify-center font-semibold text-violet-500 border-2 border-violet-500 rounded-md hover:bg-violet-500 hover:text-white focus:outline-none duration-300 "
        onClick={() => {
          valid();
        }}
      >
        <i className="fas fa-save" />
        <span className="ml-2">Хадгалах</span>
      </button>
    </div>
  );
};

export default React.memo(Index);
